"use client";

import {ReactNode} from "react";

import {useSidebar} from "./SidebarContext";
import NavLeftSidebar from "./NavLeftSidebar";
import {Locale} from "@/i18n-config";

export default function SiteGrid({children, footer, locale}: {children: ReactNode; footer: ReactNode; locale: Locale}) {
  const {open} = useSidebar();

  return (
    <div className="grid min-h-0 md:[grid-template-columns:auto_minmax(0,1fr)]">
      <div
        className={`h-full overflow-x-hidden md:overflow-visible transition-[width] duration-300 ease-in-out
          ${open ? "md:w-[14rem]" : "md:w-0"}`}>
        <NavLeftSidebar locale={locale} />
      </div>

      {/* ───────── Main content ───────── */}
      <div className="flex flex-col min-h-0 overflow-y-auto pt-header-h ">
        <main className="flex-1">{children}</main>
        {footer}
      </div>
    </div>
  );
}
